/* eslint-disable max-len */

import {
  VOCABULARY_LIST_SET_TERM_IDS,
  VOCABULARY_LIST_SET_CURRENT_TERM_NAME,
  VOCABULARY_LIST_EDITING_SET_EDIT_WORDS_CHECKLIST,

  VOCABULARY_LIST_FETCH_TERMS,
  VOCABULARY_LIST_DOWNLOAD_VOCAB_CSV,
  VOCABULARY_LIST_SET_LIST_STATE,
  VOCABULARY_LIST_SET_LIST_STATE_NOT_LOADED,
  VOCABULARY_LIST_SET_LIST_STATE_LOADING,
  VOCABULARY_LIST_SET_LIST_STATE_LOADED,
  VOCABULARY_LIST_SET_LIST_STATE_LOAD_ERROR,

  VOCABULARY_LIST_SET_EDITING_STATE,
  VOCABULARY_LIST_SET_EDITING_STATE_NOT_LOADED,
  VOCABULARY_LIST_SET_EDITING_STATE_LOADING,
  VOCABULARY_LIST_SET_EDITING_STATE_LOADED,
  VOCABULARY_LIST_SET_EDITING_STATE_LOAD_ERROR,

  VOCABULARY_LIST_LIST_STATE_NOT_LOADED,
  VOCABULARY_LIST_LIST_STATE_LOADING,
  VOCABULARY_LIST_LIST_STATE_LOADED,
  VOCABULARY_LIST_LIST_STATE_ERROR,

  VOCABULARY_LIST_SET_LIST_EDIT_STATE,
  VOCABULARY_LIST_EDITING_STATE_NOT_LOADED,
  VOCABULARY_LIST_EDITING_STATE_LOADING,
  VOCABULARY_LIST_EDITING_STATE_LOADED,
  VOCABULARY_LIST_EDITING_STATE_ERROR,

  VOCABULARY_LIST_START_ADDING_VOCABULARY,
  VOCABULARY_LIST_SAVE_ADDING_VOCABULARY,
  VOCABULARY_LIST_STOP_ADDING_VOCABULARY,

  VOCABULARY_LIST_ADDING_STATE_NOT_ADDING_VOCABULARY,
  VOCABULARY_LIST_ADDING_STATE_ADDING_VOCABULARY,
  VOCABULARY_LIST_ADDING_STATE_SAVING_VOCABULARY,
  VOCABULARY_LIST_SET_ADDING_STATE,

  VOCABULARY_LIST_SET_NEW_VOCABULARY_NAME,
  VOCABULARY_LIST_SET_NEW_VOCABULARY_TERMS,
  VOCABULARY_LIST_SET_NEW_VOCABULARY_WEIGHT,
  VOCABULARY_LIST_ADDING_VOCABULARY_RESET,
  VOCABULARY_LIST_SET_TAB_KEY,
  VOCABULARY_LIST_ADD_NEW_VOCABULARY,
  VOCABULARY_LIST_DELETE_CHECKED_LISTS,
  VOCABULARY_LIST_SET_CLEAR_FLAG,
} from './terminusConstants';

import { updateAction, makeSetValueAction, makeAction, keyToValueAction } from '../utils';
import { SPOTTING_GROUP_DOWNLOAD_GROUP } from '../spottingGroup/spottingGroupConstants';

// ------------ ACTIONS

const mutators = new Map();

/**
 *
 * SOURCE DATA:
 *
 * {
  "vocabularies": [ // <-- all the vocabularies
    {               // <-- one vocabulary
      "vocabularyName": "Custom_Vocab_US",
      "vocabularyType": "terms",
      "terms": [     // <-- vocabulary terms/terms
        {
          "term": "cash conversion cycle"
        },
        {
          "term": "service provider"
        },
        {
          "term": "voice based"
        },
        {
          "term": "experience"
        },
        {
          "term": "customer"
        }
      ]
    },
    {
      "vocabularyName": "NullTermsCustomVocab",
      "vocabularyType": "terms",
      "terms": [
        {
          "term": "capella group"
        },
        {
          "term": "crowds"
        }
      ]
    },
 *
 *
 */
const providers = {
  setTabKey: keyToValueAction(mutators, VOCABULARY_LIST_SET_TAB_KEY, 'tabKey'),
  fetchTerms: makeAction(mutators, VOCABULARY_LIST_FETCH_TERMS, s => s),
  deleteCheckedLists: makeAction(mutators, VOCABULARY_LIST_DELETE_CHECKED_LISTS, s => s),
  setTermIDs: keyToValueAction(mutators, VOCABULARY_LIST_SET_TERM_IDS, 'termIDs'),
  setCurrentVocabularyNameID: updateAction(mutators, VOCABULARY_LIST_SET_CURRENT_TERM_NAME, 'vocabularyName'),
  addNewVocabulary: updateAction(
    mutators, VOCABULARY_LIST_ADD_NEW_VOCABULARY,
    state => state,
  ),
  downloadVocabCSV: makeAction(mutators, VOCABULARY_LIST_DOWNLOAD_VOCAB_CSV, s => s),

  // this is the "temporary" name while editing a term.
  setListState: keyToValueAction(mutators, VOCABULARY_LIST_SET_LIST_STATE, 'listState'),
  setListEditState: keyToValueAction(mutators, VOCABULARY_LIST_SET_LIST_EDIT_STATE, 'listEditState'),
  setListStateChecks: keyToValueAction(mutators, VOCABULARY_LIST_EDITING_SET_EDIT_WORDS_CHECKLIST, 'listChecklist'),
  setListClearFlag: keyToValueAction(mutators, VOCABULARY_LIST_SET_CLEAR_FLAG, 'listChecklistClearFlag'),

  setListStateNotLoaded: makeSetValueAction(mutators, VOCABULARY_LIST_SET_LIST_STATE_NOT_LOADED, 'listState', VOCABULARY_LIST_LIST_STATE_NOT_LOADED),
  setListStateLoading: makeSetValueAction(mutators, VOCABULARY_LIST_SET_LIST_STATE_LOADING, 'listState', VOCABULARY_LIST_LIST_STATE_LOADING),
  setListStateLoaded: makeSetValueAction(mutators, VOCABULARY_LIST_SET_LIST_STATE_LOADED, 'listState', VOCABULARY_LIST_LIST_STATE_LOADED),
  setListStateLoadError: makeSetValueAction(mutators, VOCABULARY_LIST_SET_LIST_STATE_LOAD_ERROR, 'listState', VOCABULARY_LIST_LIST_STATE_ERROR),

  setAddingState: keyToValueAction(mutators, VOCABULARY_LIST_SET_ADDING_STATE, 'addVocabularyState'),
  setAddingStateNotAdding: makeSetValueAction(mutators, VOCABULARY_LIST_STOP_ADDING_VOCABULARY, 'addVocabularyState', VOCABULARY_LIST_ADDING_STATE_NOT_ADDING_VOCABULARY),
  setAddingStateAdding: makeSetValueAction(mutators, VOCABULARY_LIST_START_ADDING_VOCABULARY, 'addVocabularyState', VOCABULARY_LIST_ADDING_STATE_ADDING_VOCABULARY),
  setAddingStateSaving: makeSetValueAction(mutators, VOCABULARY_LIST_SAVE_ADDING_VOCABULARY, 'addVocabularyState', VOCABULARY_LIST_ADDING_STATE_SAVING_VOCABULARY),

  setAddVocabularyName: keyToValueAction(mutators, VOCABULARY_LIST_SET_NEW_VOCABULARY_NAME, 'addingVocabularyName'),
  setAddVocabularyTerms: keyToValueAction(mutators, VOCABULARY_LIST_SET_NEW_VOCABULARY_TERMS, 'addingVocabularyTerms'),
  setAddVocabularyWeight: keyToValueAction(mutators, VOCABULARY_LIST_SET_NEW_VOCABULARY_WEIGHT, 'addingVocabularyWeight'),
  addingVocabularyReset: makeAction(mutators, VOCABULARY_LIST_ADDING_VOCABULARY_RESET, (state) => {
    const newState = Object.assign({}, state, {
      addingVocabularyName: '',
      addingVocabularyTerms: '',
      addingVocabularyWeight: 0,
      addingVocabularyTermsList: [],
      tabKey: 'preview',
    });
    return newState;
  }),

  setEditingState: keyToValueAction(mutators, VOCABULARY_LIST_SET_EDITING_STATE, 'editingState'),
  setEditingStateNotLoaded: makeSetValueAction(mutators, VOCABULARY_LIST_SET_EDITING_STATE_NOT_LOADED, 'editingState', VOCABULARY_LIST_EDITING_STATE_NOT_LOADED),
  setEditingStateLoading: makeSetValueAction(mutators, VOCABULARY_LIST_SET_EDITING_STATE_LOADING, 'editingState', VOCABULARY_LIST_EDITING_STATE_LOADING),
  setEditingStateLoaded: makeSetValueAction(mutators, VOCABULARY_LIST_SET_EDITING_STATE_LOADED, 'editingState', VOCABULARY_LIST_EDITING_STATE_LOADED),
  setEditingStateLoadError: makeSetValueAction(mutators, VOCABULARY_LIST_SET_EDITING_STATE_LOAD_ERROR, 'editingState', VOCABULARY_LIST_EDITING_STATE_ERROR),
};

// -------------- RESOLVER

const initialValue = {
  termIDs: [],
  listChecklist: [],
  tabKey: 'preview',
  listState: VOCABULARY_LIST_LIST_STATE_NOT_LOADED,
  listEditState: false,
  editingState: VOCABULARY_LIST_EDITING_STATE_NOT_LOADED,
  addVocabularyState: VOCABULARY_LIST_ADDING_STATE_NOT_ADDING_VOCABULARY,
  addingVocabularyName: '',
  addingVocabularyTerms: '',
  addingVocabularyWeight: 0,
  addingVocabularyTermsList: [],
  listChecklistClearFlag: false,
};

const resolver = (state = initialValue, { type, payload }) => {
  if (!mutators.has(type)) {
    return state;
  }

  return mutators.get(type)(state, payload);
};

export default resolver;

const actions = Array.from(mutators.keys());

export {
  actions,
  providers,
};
